import { render, staticRenderFns } from "./PropiedadDetalle.vue?vue&type=template&id=2feddb76&scoped=true&"
import script from "./PropiedadDetalle.vue?vue&type=script&lang=js&"
export * from "./PropiedadDetalle.vue?vue&type=script&lang=js&"
import style0 from "./PropiedadDetalle.vue?vue&type=style&index=0&id=2feddb76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feddb76",
  null
  
)

export default component.exports